import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import i18n from 'simple-react-i18n'
import {
    H_CAMPAIGN_PIEZO_DASHBOARD,
    H_CAMPAIGN_PIEZO_MAT,
    H_CAMPAIGN_PIEZO_TRACKING,
} from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CityAction from '../../../referencial/components/city/actions/CityAction'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import PiezometryAction from '../../actions/PiezometryAction'
import { Box, Card, CardContent, Stack } from '@mui/material'
import ProgressBar from 'components/progress/ProgressBar'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ReferencialAction from 'referencial/action/ReferencialAction'

const PiezometryCampaignApp = ({}) => {
    const { id } = useParams()
    const dispatch = useDispatch()

    const links = id !== 'new' ? [
        {
            href: `/piezometry/campaign/${id}/dashboard`,
            icons: 'dashboard',
            name: i18n.dashboard,
            habilitation: H_CAMPAIGN_PIEZO_DASHBOARD,
        },
        {
            href: `/piezometry/campaign/${id}/tracking`,
            icons: 'insert_drive_file',
            name: i18n.tracking,
            habilitation: H_CAMPAIGN_PIEZO_TRACKING,
        },
        {
            href: `/piezometry/campaign/${id}/materiel`,
            icons: 'router',
            name: i18n.materiels,
            habilitation: H_CAMPAIGN_PIEZO_MAT,
        },
        {
            href: `/piezometry/campaign/${id}/picture`,
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            habilitation: H_CAMPAIGN_PIEZO_DASHBOARD,
        },
    ] : [{
        href: `/piezometry/campaign/${id}/dashboard`,
        icons: 'dashboard',
        name: i18n.dashboard,
        habilitation: H_CAMPAIGN_PIEZO_DASHBOARD,
    }].filter(l => componentHasHabilitations(l.habilitation))

    useEffect(() => {
        return () => {
            dispatch(CampaignAction.resetCampaign())
        }
    }, [])

    const { progress, isLoaded } = useProgressDispatch(() => {
        const campaignFetch = id !== 'new' ?
            [
                dispatch(CampaignAction.fetchCampaign('piezometry', id)),
                dispatch(CampaignAction.fetchCampaignStation('piezometry', id)),
                dispatch(CampaignAction.fetchCampaignProgress('piezometry', id)),
                dispatch(CampaignAction.fetchStationCampaignDetails('piezometry', id)),
            ]
            :
            []
        return [
            dispatch(PiezometryAction.fetchPiezometersLight()),
            dispatch(CityAction.fetchCities()),
            dispatch(ContactAction.fetchContacts()),
            dispatch(ReferencialAction.fetchSandreCodes()),
            ...campaignFetch,
        ]
    }, [id])

    return (
        <Box>
            <FixedSlideNav links={links} />
            <Box padding={1} className='content-page fullscreen'>
                <BoundaryError>
                    {isLoaded ?
                        <Outlet />
                        :
                        <Stack padding={1}>
                            <Card>
                                <CardContent>
                                    <ProgressBar progress={progress} withMessage />
                                </CardContent>
                            </Card>
                        </Stack>
                    }
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default PiezometryCampaignApp
